import invariant from 'invariant';
import PropTypes from 'prop-types';
import { isServerSideRendering } from '@dbh/environment';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

const throwInServerSideRendering=withConformsTo("throwInServerSideRendering",["fnName",PropTypes.string.isRequired],a=>{invariant(!isServerSideRendering(),"(`"+a+"`) This code is not compatible with server side rendering, it needs a browser with `window` defined.");});

export { throwInServerSideRendering as default };
